import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

let canPlay = true

export default class ThunderComponent extends Component {
  init() {
    this.audioPath = '/static/media/thunder.mp3'
    this.audios = []

    this.observer = new MutationObserver(mutations => this.onMutationHandler(mutations))
    this.observer.observe(document.documentElement, { subtree: false, childList: false, attributes: true, attributeFilter: ['class'], attributeOldValue: false, characterData: false, characterDataOldValue: false })
  }

  onMutationHandler(mutations) {
    for (const mutation of mutations) {
      if (canPlay && mutation.attributeName === 'class' && mutation.target.classList.contains('konami')) {
        const audio = new Audio(this.audioPath)
        audio.volume = 0.5
        audio.play()
        this.audios.push(audio)
        canPlay = false
        window.setTimeout(() => {
          delete this.audios[this.audios.indexOf(audio)]
          canPlay = true
        }, 2500)
        break
      }
    }
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'thunder', ThunderComponent))
